module.exports = __webpack_public_path__ + "media/iconic/chevron-9d4f3651.svg";